import React, { useEffect, useState } from "react";
import {
  fetchPatientAndRelatives,
  generateOTP,
  verifyPatientOTP,
} from "../../services/patientRegistrationRequesApi";
import { useLocation, useNavigate } from "react-router-dom";

import { showToast } from "../../utils/toastUtils";
import { ToastContainer } from "react-toastify";
import { sendOtp } from "../../../clinic/services/authApi";

const OtpVerificationSection = () => {
  const location = useLocation();
  const history = useNavigate();
  // const preViousState = location?.state ?? {};
  const {
    url = "/patient/familylist",
    contactNumber,
    ...restProps
  } = location?.state ?? {};
  const [otp, setOtp] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [userId, setUserId] = useState();
  const [otpVerified, setOtpVerified] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [attemptsRemaining, setAttemptsRemaining] = useState(3);
  const [cooldown, setCooldown] = useState(false);
  const [cooldownTime, setCooldownTime] = useState(300);
  const [showAttemptsRemaining, setShowAttemptsRemaining] = useState(null);

  const handleAcceptTerms = (e) => {
    setAcceptedTerms(e.target.checked);
  };

  useEffect(() => {
    let timer;
    if (cooldown) {
      timer = setInterval(() => {
        setCooldownTime((prevTime) => prevTime - 1);
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [cooldown]);

  useEffect(() => {
    let cooldownTimer;
    if (cooldownTime <= 0) {
      setCooldown(false);
      setCooldownTime(300);
    } else if (cooldown) {
      cooldownTimer = setTimeout(() => {
        setCooldownTime((prevTime) => prevTime - 1);
      }, 1000);
    }

    return () => clearTimeout(cooldownTimer);
  }, [cooldown, cooldownTime]);

  useEffect(() => {
    if (attemptsRemaining == 0) {
      setCooldown(true);
      localStorage.setItem(contactNumber, new Date());
      setTimeout(() => setCooldown(false), 300000); // 5 minutes cooldown
      setCooldown(true);
      setErrorMessage("");
    }
  }, [attemptsRemaining]);

  useEffect(() => {
    const convertSetTimingLocal = localStorage.getItem(contactNumber);
    if (convertSetTimingLocal) {
      const time = getTimeDifferenceInSeconds(convertSetTimingLocal);

      if (time >= 300) {
        setCooldown(false);
        setAttemptsRemaining(3);
        localStorage.removeItem(contactNumber);
      } else {
        setCooldownTime(300 - time);
        setCooldown(true);
        setTimeout(() => setCooldown(false), 300000 - time * 1000); // 5 minutes cooldown
      }
    }
  }, [contactNumber]);

  const handleOtpChange = (e) => {
    setOtp(e.target.value);
  };

  const handleVerifyOtp = async () => {
    setErrorMessage("");
      const response = await verifyPatientOTP(contactNumber, otp);
      if (response?.status) {
        // Reset attempts remaining //
        showToast(response.message, "success");
        setAttemptsRemaining(3);

        
        setUserId(response.user_id);
        setOtpVerified(true);
        localStorage.setItem("pat-token", response.data.token);

        setTimeout(() => {
          history(url, { state: { ...restProps, url } });
        }, 1000);
      } else {
        //setErrorMessage("Invalid OTP. Please try again.");
        //console.error("Invalid OTP");
        showToast(response.message, "error");
      }    
  };

  const handleResendOtp = async () => {
    setErrorMessage("");

    try {
      const response = await sendOtp(contactNumber);
      if (response?.status) {
        // Display success message
        showToast("OTP resent successfully", "success");
        // Decrease attempts remaining
        setAttemptsRemaining(attemptsRemaining - 1);

      } else {
        // Display error message if resend failed
        setErrorMessage("Error resending OTP. Please try again.");
      }
    } catch (error) {
      console.error(error);
      setErrorMessage("Error resending OTP. Please try again.");
    }
  };

  function getTimeDifferenceInSeconds(givenDateTimeString) {
    const givenTime = new Date(givenDateTimeString);
    const currentTime = new Date();
    const differenceInSeconds = Math.floor(
      (currentTime.getTime() - givenTime.getTime()) / 1000
    );
    return differenceInSeconds;
  }

  return (
    <div className="flex flex-col lg:justify-center items-center bg-[#f2f9ff] pt-5 xl:pt-0 justify-center min-h-[calc(100vh-0px)] w-full">
      <div className=" py-5">
        <img
          src={"../../images/new_vitalX_logo.png"}
          className=" h-36 mx-auto "
          alt=""
        />
      </div>
      <div className="w-full md:w-8/12 lg:w-6/12 xl:w-4/12 px-5 md:px-3 xl:px-0">
        <div className="md:bg-white md:shadow-sm md:px-5 py-5 lg:px-14 lg:py-12 rounded-2xl">
          <div className="mb-8">
            <h3 className="mb-1 text-xl font-bold text-[#04225b]">
              Hello Patient Enter Your OTP
            </h3>
          </div>
          <div className="inline-flex flex-col w-full relative mb-6">
            <label
              htmlFor="otp"
              className="mb-1 text-gray-800 bg-[#f2f9ff] md:bg-white font-semibold text-[14px]"
            >
              Enter OTP
            </label>
            <input
              id="otp"
              value={otp}
              type="text"
              onChange={handleOtpChange}
              className={`min-h-[45px] w-full px-5 outline-none border-2 bg-[#f2f9ff] md:bg-white border-gray-200 rounded-md focus:ring-[#076ec7] focus:border-[#076ec7]
              ${cooldown ? " cursor-not-allowed" : ""}
              `}
              disabled={cooldown}
            />

            <div className="  flex justify-between">
              <div className=" text-red-500">{errorMessage}</div>
            </div>
          </div>
          <div className="flex items-center mb-6">
            <input
              id="terms"
              type="checkbox"
              checked={acceptedTerms}
              onChange={handleAcceptTerms}
              className="mr-2"
            />
            <label htmlFor="terms" className="text-sm text-gray-600">
              I accept the{" "}
              <a href="/terms" target="_blank" className="text-blue-600">
                Terms & Conditions
              </a>{" "}
              and{" "}
              <a href="/privacy" target="_blank" className="text-blue-600">
                Privacy Policy
              </a>
            </label>
          </div>
          <button
            type="submit"
            onClick={handleVerifyOtp}
            className={`min-w-[131px] w-full text-base font-medium rounded-lg py-2 px-5 text-white ${
              cooldown || !acceptedTerms
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-[#0188fc] hover:bg-[#076ec7]"
            }`}
            disabled={cooldown || !acceptedTerms}
          >
            Verify OTP
          </button>

          {/* Display cooldown message with timer */}
          {cooldown && (
            <div className=" mt-3 text-center ">
              Maximum attempts reached. Try again after{" "}
              <span className=" font-semibold text-xl">
                {Math.floor(cooldownTime / 60)}:
                {cooldownTime % 60 < 10
                  ? `0${cooldownTime % 60}`
                  : cooldownTime % 60}{" "}
              </span>
              minutes.
            </div>
          )}
          {attemptsRemaining > 0 && !cooldown && (
            <div className=" mt-7 flex justify-between flex-col text-center">
              <button
                className="  bg-white text-blue-700 !border border-blue-700 py-1.5 self-center"
                onClick={handleResendOtp}
              >
                Resend OTP
              </button>
            </div>
          )}

          {/* Display attempts remaining */}
          {attemptsRemaining > 0 && !cooldown && (
            <div className=" text-sm text-gray-600 text-center pt-3">
              Attempts remaining: {attemptsRemaining}
            </div>
          )}

          <ToastContainer />
        </div>
      </div>
    </div>
  );
};

export default OtpVerificationSection;
